import { useQuery } from "@tanstack/react-query";
import { getMediaEmbeddingStatus } from "#/api/mediaReference.api";

export function useMediaEmbeddingStatus(
  id: string | undefined,
  enabled: boolean
) {
  return useQuery({
    queryKey: ["media", "embedding", id],
    queryFn: () => {
      if (!id) {
        throw new Error("Media id required");
      }
      return getMediaEmbeddingStatus(id);
    },
    enabled: Boolean(id && enabled),
    refetchInterval: 4000,
    staleTime: 0,
  });
}
